import { useDispatch } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";

export const FilterComponent = ({
 main_state,
 secondary_state,
 element,
 change_able,
}) => {
 if (isNaN(main_state)) {
  if (
   element.FullTextAprt &&
   element.FullTextAprt.toLowerCase()
    .toString()
    .startsWith(main_state.toLowerCase())
  ) {
   return element.FullTextAprt.toLowerCase()
    .toString()
    .startsWith(main_state.toLowerCase());
  } else if (change_able) {
   return true;
  } else if (
   element.firstname &&
   element.firstname.toLowerCase().startsWith(main_state.toLowerCase())
  ) {
   return true;
  } else if (
   element.s_letter &&
   element.s_letter.toLowerCase().startsWith(main_state.toLowerCase())
  ) {
   return true;
  } else if (
   element.s_code &&
   element.s_code.toLowerCase().startsWith(main_state.toLowerCase())
  ) {
   return true;
  } else if (
   element.available_id &&
   element.available_id.block &&
   element.available_id.block.toLowerCase().startsWith(main_state.toLowerCase())
  ) {
   return true;
  } else if (
   element.available_id &&
   element.available_id.NOoFProperty.toString().startsWith(main_state)
  ) {
   return true;
  }
 } else if (secondary_state === "Apartment") {
  return element.available_id && element.available_id.Property === "Apartment";
 } else if (secondary_state === "House") {
  return element.available_id && element.available_id.Property === "House";
 } else if (secondary_state === "Farm") {
  return element.available_id && element.available_id.Property === "Farm";
 } else if (secondary_state === "Shop") {
  return element.available_id && element.available_id.Property === "Shop";
 } else if (secondary_state === "Vella") {
  return element.available_id && element.available_id.Property === "Vella";
 } else if (secondary_state === "Earth") {
  return element.available_id && element.available_id.Property === "Earth";
 } else if (secondary_state === "Strecture") {
  return element.available_id && element.available_id.Property === "Strecture";
 } else if (secondary_state === "The gas station") {
  return (
   element.available_id && element.available_id.Property === "The gas station"
  );
 } else if (secondary_state === "Factory") {
  return element.available_id && element.available_id.Property === "Factory";
 } else if (secondary_state === "GYM") {
  return element.available_id && element.available_id.Property === "GYM";
 } else if (secondary_state === "store") {
  return element.available_id && element.available_id.Property === "store";
 } else if (secondary_state === "Restaurant") {
  return element.available_id && element.available_id.Property === "Restaurant";
 } else if (secondary_state === "Commercial Land") {
  return (
   element.available_id && element.available_id.Property === "Commercial Land"
  );
 } else if (secondary_state === "Company") {
  return element.available_id && element.available_id.Property === "Company";
 } else if (secondary_state === "Hotel") {
  return element.available_id && element.available_id.Property === "Hotel";
 } else if (secondary_state === "Car Garage") {
  return element.available_id && element.available_id.Property === "Car Garage";
 } else if (secondary_state === "Stadium") {
  return element.available_id && element.available_id.Property === "Stadium";
 } else if (secondary_state === "Car wash") {
  return element.available_id && element.available_id.Property === "Car wash";
 } else if (secondary_state === "Building") {
  return element.available_id && element.available_id.Property === "Building";
 } else if (secondary_state === "Agitator") {
  return element.available_id && element.available_id.Property === "Agitator";
 } else if (secondary_state === "residential community") {
  return (
   element.available_id &&
   element.available_id.Property === "residential community"
  );
 } else if (secondary_state === "agricultural land of the register") {
  return (
   element.available_id &&
   element.available_id.Property === "agricultural land of the register"
  );
 } else if (secondary_state === "unregistered agricultural land") {
  return (
   element.available_id &&
   element.available_id.Property === "unregistered agricultural land"
  );
 } else if (secondary_state === "Government agricultural land") {
  return (
   element.available_id &&
   element.available_id.Property === "Government agricultural land"
  );
 } else if (secondary_state === "Land of Istamar") {
  return (
   element.available_id && element.available_id.Property === "Land of Istamar"
  );
 } else if (secondary_state === "Erth Musataha") {
  return (
   element.available_id && element.available_id.Property === "Erth Musataha"
  );
 } else if (secondary_state === "school") {
  return element.available_id && element.available_id.Property === "school";
 } else if (secondary_state === "Building of Istamar") {
  return (
   element.available_id &&
   element.available_id.Property === "Building of Istamar"
  );
 } else if (secondary_state === "Building of Musataha") {
  return (
   element.available_id &&
   element.available_id.Property === "Building of Musataha"
  );
 } else {
  if (
   element.lastPrice &&
   element.lastPrice.toString().startsWith(main_state)
  ) {
   return true;
  } else if (
   element.available_id &&
   element.available_id.NOoFProperty.toString().startsWith(main_state)
  ) {
   return true;
  } else if (
   element.s_code &&
   element.s_code.toString().startsWith(main_state)
  ) {
   return true;
  } else {
   return (
    element.InvoiceNO && element.InvoiceNO.toString().startsWith(main_state)
   );
  }
 }
};

export const FilterComponent_Bills = ({
 main_state,
 secondary_state,
 element,
 name,
 name_2,
}) => {
 // Skip deleted elements or if element is not valid
 if (!element || element.status === "delete") {
  return false;
 }

 // Define valid bill types for cleaner lookup
 const validBillTypes = [
  "Monthly rent invoice",
  "Service Bill",
  "Insurance Bill",
  "Sell",
  "Arabun",
  "comision",
  "investor",
  "Buy",
 ];

 // Helper function to check if a field starts with search term (case-insensitive)
 const startsWithIgnoreCase = (field, searchTerm) => {
  if (!field || !searchTerm || field === undefined || field === null)
   return false;
  try {
   const fieldStr = String(field).toLowerCase();
   const searchStr = String(searchTerm).toLowerCase();
   return fieldStr.startsWith(searchStr);
  } catch (error) {
   console.warn("FilterComponent_Bills: Error in startsWithIgnoreCase:", error);
   return false;
  }
 };

 // Check if we have any active filters
 const hasTextSearch =
  main_state &&
  main_state !== "" &&
  main_state !== null &&
  main_state !== undefined;
 const hasTypeFilter =
  secondary_state &&
  secondary_state !== "" &&
  validBillTypes.includes(secondary_state);

 // Debug logging
 if (secondary_state && secondary_state !== "") {
  console.log("FilterComponent_Bills Debug:", {
   secondary_state,
   element_type: element.type,
   hasTypeFilter,
   validBillTypes,
   includes_check: validBillTypes.includes(secondary_state),
  });
 }

 // If no filters are active, show all items
 if (!hasTextSearch && !hasTypeFilter) {
  return true;
 }

 // Apply type filter if active
 if (hasTypeFilter) {
  const typeMatches = element.type === secondary_state;

  // If we also have text search, both must match
  if (hasTextSearch) {
   if (!typeMatches) return false;

   // Check text search
   if (isNaN(main_state)) {
    const searchFields = [
     name,
     name_2,
     element?.num,
     element?.place,
     element?.property,
    ].filter((field) => field != null);
    return searchFields.some((field) =>
     startsWithIgnoreCase(field, main_state)
    );
   } else {
    // Numeric search
    const numericFields = [element?.Amount, element?.invoice_No].filter(
     (field) => field != null
    );
    return numericFields.some((field) => {
     try {
      return String(field).startsWith(String(main_state));
     } catch (error) {
      console.warn("FilterComponent_Bills: Error in numeric search:", error);
      return false;
     }
    });
   }
  }

  // Only type filter is active
  return typeMatches;
 }

 // Only text search is active
 if (hasTextSearch) {
  if (isNaN(main_state)) {
   const searchFields = [
    name,
    name_2,
    element?.num,
    element?.place,
    element?.property,
   ].filter((field) => field != null);
   return searchFields.some((field) => startsWithIgnoreCase(field, main_state));
  } else {
   // Numeric search
   const numericFields = [element?.Amount, element?.invoice_No].filter(
    (field) => field != null
   );
   return numericFields.some((field) => {
    try {
     return String(field).startsWith(String(main_state));
    } catch (error) {
     console.warn("FilterComponent_Bills: Error in numeric search:", error);
     return false;
    }
   });
  }
 }

 // Fallback
 return true;
};

export const FilterComponent_Properties = ({
 main_state,
 secondary_state,
 third_state,
 element,
 lang,
 type,
}) => {
 const dispatch = useDispatch();
 if (element.status !== "delete" && element.status !== "Rejected") {
  if (main_state !== "") {
   if (isNaN(main_state)) {
    if (element.block && element.block.toString().startsWith(main_state)) {
     return element.block && element.block.toString().startsWith(main_state);
    } else if (
     element.NOoFProperty &&
     element.NOoFProperty.toString().startsWith(main_state)
    ) {
     return (
      element.NOoFProperty &&
      element.NOoFProperty.toString().startsWith(main_state)
     );
    } else if (
     element.s_letter &&
     element.s_letter.toString().startsWith(main_state)
    ) {
     return (
      element.s_letter && element.s_letter.toString().startsWith(main_state)
     );
    } else if (
     element.s_code &&
     element.s_code.toString().startsWith(main_state)
    ) {
     return element.s_code && element.s_code.toString().startsWith(main_state);
    } else if (
     element.Place_ku &&
     element.Place_ku.toLowerCase().startsWith(main_state.toLowerCase())
    ) {
     return lang === "krd"
      ? element.Place_ku &&
         element.Place_ku.toLowerCase().startsWith(main_state.toLowerCase())
      : lang === "en"
      ? element.Place_en &&
        element.Place_en.toLowerCase().startsWith(main_state.toLowerCase())
      : element.Place_ar &&
        element.Place_ar.toLowerCase().startsWith(main_state.toLowerCase());
    } else if (
     element.Property !== null &&
     element.Property !== undefined &&
     element.Property !== ""
    ) {
     return (
      dispatch(change_Lang(element.Property)) &&
      dispatch(change_Lang(element.Property))
       .toLowerCase()
       .startsWith(main_state.toLowerCase())
     );
    } else if (
     element.block &&
     element.block.toLowerCase().startsWith(main_state.toLowerCase())
    ) {
     return (
      element.block &&
      element.block.toLowerCase().startsWith(main_state.toLowerCase())
     );
    }
   } else if (element.Area && element.Area.toString().startsWith(main_state)) {
    return element.Area && element.Area.toString().startsWith(main_state);
   } else if (
    element.flour &&
    element.flour.toString().startsWith(main_state)
   ) {
    return element.flour && element.flour.toString().startsWith(main_state);
   } else if (
    element.price &&
    element.price.toString().startsWith(main_state)
   ) {
    return element.price && element.price.toString().startsWith(main_state);
   } else if (
    element.NOoFProperty &&
    element.NOoFProperty.toString().startsWith(main_state)
   ) {
    return (
     element.NOoFProperty &&
     element.NOoFProperty.toString().startsWith(main_state)
    );
   } else if (
    element.s_code &&
    element.s_code.toString().startsWith(main_state)
   ) {
    return element.s_code && element.s_code.toString().startsWith(main_state);
   }
  } else if (secondary_state === true) {
   return element.status !== type && element.status !== "deactive";
  } else if (third_state === true) {
   return element.status === type;
  } else {
   return element;
  }
 }
};
